import { Box, Container } from "@mui/material";
import PageAppBar from "./PageAppBar";
import Invites from "./Invites";
import AudienceCap from "./AudienceCap";
import ArtistAccountTabs from "@/components/ArtistAccountTabs";
export default function Admin() {
  return (
    <Container maxWidth="sm" sx={{ py: 10 }}>
      <Box>
        <PageAppBar />
        <ArtistAccountTabs />
        <AudienceCap />
        <Invites />
      </Box>
    </Container>
  );
}
